import React from "react";
import "./style.css";
import Navbar from "../../Components/Navbar";
import { useState } from "react";

function App() {
  const [file, setFile] = useState(null);

  return (
    <>
      <div className="carousal-container">
        <form>
          <h1>Carousal File Upload</h1>
          <input type="file" className="file-upload" />
        </form>
      </div>
    </>
  );
}

export default App;
